"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreLegalQuestionnaireStepToJSON = exports.PreLegalQuestionnaireStepFromJSONTyped = exports.PreLegalQuestionnaireStepFromJSON = void 0;
function PreLegalQuestionnaireStepFromJSON(json) {
    return PreLegalQuestionnaireStepFromJSONTyped(json, false);
}
exports.PreLegalQuestionnaireStepFromJSON = PreLegalQuestionnaireStepFromJSON;
function PreLegalQuestionnaireStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'usCitizenOrNationalOrLPR': json['usCitizenOrNationalOrLPR'],
        'disqualifyingFelonyPartA': json['disqualifyingFelonyPartA'],
        'disqualifyingFelonyPartB': json['disqualifyingFelonyPartB'],
        'releasedFromIncarcerationPartB': json['releasedFromIncarcerationPartB'],
        'wantedOrUnderIndictment': json['wantedOrUnderIndictment'],
        'mentalCapacityLegalHistory': json['mentalCapacityLegalHistory'],
    };
}
exports.PreLegalQuestionnaireStepFromJSONTyped = PreLegalQuestionnaireStepFromJSONTyped;
function PreLegalQuestionnaireStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'usCitizenOrNationalOrLPR': value.usCitizenOrNationalOrLPR,
        'disqualifyingFelonyPartA': value.disqualifyingFelonyPartA,
        'disqualifyingFelonyPartB': value.disqualifyingFelonyPartB,
        'releasedFromIncarcerationPartB': value.releasedFromIncarcerationPartB,
        'wantedOrUnderIndictment': value.wantedOrUnderIndictment,
        'mentalCapacityLegalHistory': value.mentalCapacityLegalHistory,
    };
}
exports.PreLegalQuestionnaireStepToJSON = PreLegalQuestionnaireStepToJSON;
//# sourceMappingURL=PreLegalQuestionnaireStep.js.map